module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_02_american-village-cdc5eeb746dc85f58791e0d7327383fd.jpg";